var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6032 32C7.37349 32 5.25858 32 3.66668 31.1249C2.49016 30.478 1.52195 29.51 0.875153 28.3333C0 26.7414 0 24.6265 0 20.3968V11.6032C0 7.37349 0 5.25858 0.875153 3.66668C1.52195 2.49016 2.49016 1.52195 3.66668 0.875153C5.25858 0 7.37349 0 11.6032 0H20.3968C24.6265 0 26.7414 0 28.3333 0.875153C29.51 1.52195 30.478 2.49016 31.1249 3.66668C32 5.25858 32 7.37349 32 11.6032V20.3968C32 24.6265 32 26.7414 31.1249 28.3333C30.478 29.51 29.51 30.478 28.3333 31.1249C26.7414 32 24.6265 32 20.3968 32H11.6032Z",
    fill: "url(#paint0_linear_7752_20238)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5609 26.5825H17.6128C23.6062 26.5825 26.0802 20.5086 23.2009 15.8025C21.1641 12.4731 17.0272 12.3135 16.4536 15.4293C16.4045 15.7423 16.4045 16.0667 16.4536 16.3797C17.0272 19.4955 21.1641 19.3358 23.2009 16.0066C26.0802 11.3004 23.6062 5.22656 17.6128 5.22656H11.5609C9.26884 5.22656 7.52637 6.86378 7.52637 9.3196V15.6346V22.4895C7.52637 24.9452 9.26884 26.5825 11.5609 26.5825Z",
    stroke: "white",
    strokeWidth: 2.33888
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6124 5.22656C23.6057 5.22656 26.0797 11.3004 23.2005 16.0066C21.1636 19.3358 17.0269 19.4955 16.4531 16.3797",
    stroke: "url(#paint1_linear_7752_20238)",
    strokeWidth: 2.33888
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6124 26.582C23.6057 26.582 26.0797 20.5081 23.2005 15.802C21.1636 12.4726 17.0269 12.313 16.4531 15.4288",
    stroke: "white",
    strokeWidth: 2.33888
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7752_20238",
    x1: 10.5388,
    y1: 8.87953,
    x2: 16.0001,
    y2: 29.6284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C700CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7752_20238",
    x1: 22.9759,
    y1: 11.3808,
    x2: 19.0025,
    y2: 17.3682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371814,
    stopColor: "#EACAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481371,
    stopColor: "#D494D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618931,
    stopColor: "#E9C8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logo_only.93da65608ad256ffea4215f650aa523a.svg";
export { ForwardRef as ReactComponent };